import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { UserDetailsFormDataUserEdit } from '@/common/viewModels/userDetails/form/data/UserDetailsFormDataUserEdit';
import { UserDetailsFormStateUserEdit } from '@/common/viewModels/userDetails/form/state/UserDetailsFormStateUserEdit';
import { ItemViewModel } from '@/common/viewModels';
import { TenantRoleType } from '@/common/viewModels/Enums';
import { TelstraUIVueDialog } from '@/external/telstra-ui-vue/components';

@Component({
  components: {
    TelstraUIVueDialog,
  },
})

export default class UserDetailsEditUserModal extends Vue {
  @Prop({ required: true }) data!: UserDetailsFormDataUserEdit;
  @Prop({ required: true }) state!: UserDetailsFormStateUserEdit;
  @Prop({ required: true }) serverError!: string;
  @Prop({ default: false }) isLoading!: boolean;
  @Prop({ default: true }) isEditUserFormValid!: boolean;

  roleOptions: ItemViewModel[] = [
    { text: 'Tenancy Administrator', value: TenantRoleType.TenancyAdministrator, disabled: false },
    { text: 'Tenancy Manager', value: TenantRoleType.TenancyManager, disabled: false },
    { text: 'Tenancy Reader', value: TenantRoleType.TenancyReader, disabled: false },
    { text: 'No Tenancy Access', value: TenantRoleType.TenancyNoAccess, disabled: false },
  ];

  showModal(): void {
    (this.$refs.modalEditUser as any).show();
  }

  hideModal(): void {
    (this.$refs.modalEditUser as any).hide();
  }

  @Emit()
  onFormInputChange(inputEvent: any) {
    const target: any = inputEvent.target;
    this.$emit('editUserFormInputChange', target.name, target.value);
  }

  @Emit()
  onUpdateUser(): void {
    this.$emit('editTenantUser');
  }
}
